import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoutes = () => {
	const location = useLocation();
	const token = localStorage.getItem('accessToken');
	return !token ? <Navigate to='/login' /> : <Outlet />;
};

export default PrivateRoutes;
